import { Component, OnInit, AfterViewChecked } from '@angular/core';
import { UtilsService } from 'src/app/shared/utils.service';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { CardBillingComponent } from '../../manufacturer/sponsoring/billing/card-billing/card-billing.component';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { DataService } from 'src/app/shared/data.service';

declare let paypal: any;

@Component({
    selector: 'app-signup-billing',
    templateUrl: './signup-billing.component.html',
    styleUrls: ['./signup-billing.component.scss'],
    standalone: false
})
export class SignupBillingComponent implements AfterViewChecked {
  billingForm: any;
  addScript: boolean = false;
  paypalload = false;

  paypalconfig = {
    env: 'sandbox',
    client: {
      sandbox: 'AfLwhc2UmYN5ZDlvYP1PUWMPvJ76PoQ5m9IBmjkMUJ8pSe9xAuKXY_WwkFVfwPq3gPmeoEEv6Scu-FOe',
      // production: 'AfGW-J6bzgmG72HAUg9T_nEV3fBBuEcSXlXFcKNCmLdxHSWG2It_vYO6EYNlhIGSBkoptFAHS8DmRGZO'
    },
    commit: true,
    payment: (data, actions) => {
      return actions.payment.create({
        payment: {
          transactions: [
            {amount: {total: this.annualFee, currency: 'EUR'}}
          ]
        }
      });
    },
    onError:  (data, actions) => {
    },
    onAuthorize: (data, actions) => {
      return actions.payment.execute().then(function(payment) {
        const payload = {
          Amount: parseInt( this.annualFee , 10),
          Currency: 'EUR',
          Description: 'Buy ' + this.plan + 'plan',
          Token: payment.id,
          Type: 1
        };
        this.dataService.post('billing/BillingGateway', payload).then((billingData) => {
        if (billingData.statusCode === 200) {
              this.dialog.closeAll();
              this.signup();
            } else {
              const dialogRef = this.dialog.open(AlertDialogComponent, {
                disableClose: true,
                width: '400px',
                data: {
                  title: 'Error',
                  type: 'Error',
                  message: 'something went wrong, please try again!',
                  buttonText: 'Ok'
                }
              });
            }
          });
        });
      },
    style: {
      color: 'black',
      shape: 'rect',
      label: 'checkout',
      tagline: false,
      layout: 'vertical'
    },
    funding:
    {
        disallowed: [ ]
    },
  };
  annualFee: any;
  signupPayload: any;
  plan: any;

  constructor(private utils: UtilsService, public dialog: MatDialog,
              public router: Router, private route: ActivatedRoute,
              private dataService: DataService) {
                this.route.params
                .subscribe(
                (params: Params) => {
                this.annualFee = params.annualFee;
                });
                if (this.router.currentNavigation() && this.router.currentNavigation()?.extras.state) {
                  this.signupPayload = this.router.currentNavigation()?.extras.state?.data;
                  this.plan = this.router.currentNavigation()?.extras.state?.plan;
                }
              }
  ngAfterViewChecked(): void {
    if (!this.addScript) {
      this.addPaypalScript().then(() => {
        // this.paypalconfig.funding = {disallowed: [ paypal.FUNDING.CREDIT ]};
        paypal.Button.render(this.paypalconfig, '#paypal-checkout-btn');
        this.paypalload = true;
      });
    }
  }

  ngOnInit(): void {
    this.billingForm = new FormGroup({
      annualFee: new FormControl({ value: this.annualFee, disabled: true }),
    });
  }

  addPaypalScript() {
    this.addScript = true;
    return new Promise((resolve, reject) => {
      const scripttagelement = document.createElement('script');
      scripttagelement.src = 'https://www.paypalobjects.com/api/checkout.js';
      scripttagelement.onload = resolve;
      document.body.appendChild(scripttagelement);
    });
  }

  buyWithCard() {
    const dialogRef = this.dialog.open(CardBillingComponent,
      {disableClose: true, width: '400px', data: {totalAmount: this.annualFee, plan: this.plan}});
    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'success') {
          this.signup();
      }
    });
  }

  signup() {
    this.signupPayload.plan = this.plan;
    this.dataService.post('auth/signup', this.signupPayload).then((data) => {
      this.router.navigate(['/home-script']);
      if (data.statusCode === 200) {
        this.dialog.closeAll();
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Signed Up successfully',
            type: 'Success',
            message: 'You are signed up successfully, please wait for admin approval',
            buttonText: 'Ok'
          }
        });
      } else if (data.statusCode === 400 || data.statusCode === 600) {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Error while signing up',
            type: 'Error',
            message: 'Please try again!',
            buttonText: 'Ok'
          }
        });
      }
    });
  }
}
